import { render, staticRenderFns } from "./accountShow.vue?vue&type=template&id=2fe789fb"
import script from "./accountShow.vue?vue&type=script&lang=js"
export * from "./accountShow.vue?vue&type=script&lang=js"
import style0 from "./accountShow.vue?vue&type=style&index=0&id=2fe789fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports